import { Box, withStyles } from '@material-ui/core';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsCurrency from 'ui-elements/common-elements/FsCurrency';
import { purple } from 'globals/colors';

export const Row = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    padding: spacing(0, 2),
    marginBottom: spacing(2),
  },
}))(Box);

export const RowSpecial = withStyles(({ spacing }) => ({
  root: {
    padding: spacing(2, 2),
    borderRadius: spacing(1),
    backgroundColor: purple.V4,
  },
}))(Row);

export const Caption = withStyles(() => ({
  root: {
    width: '100%',
  },
}))(FsBodySmall);

export const CaptionSpecial = withStyles(() => ({
  root: {
    fontSize: 18,
  },
}))(Caption);

export const Currency = withStyles(({ spacing }) => ({
  root: {
    flexShrink: 0,
    fontSize: 14,
    fontWeight: 700,
    marginLeft: spacing(2),
  },
}))(FsCurrency);

export const CurrencySpecial = withStyles(() => ({
  root: {
    fontSize: 18,
  },
}))(Currency);

export const Legend = withStyles(() => ({
  root: {},
}))(FsBodySmall);
